export const ARG_TYPE_UNSPECIFIED = 'Argument type not specify';

/*
 * Génére un action creator
 * exemple utilisation : export const addTodo = makeActionCreator(ADD_TODO, 'todo');
 */

export function makeActionCreator(type, ...argNames) {
    if (!type) {
        throw new Error(ARG_TYPE_UNSPECIFIED);
    }
    return function(...args) {
        let action = { type };
        argNames.forEach((arg, index) => {
            action[argNames[index]] = args[index];
        });
        return action;
    };
}

/*
 * retourne un json similaire au json/objet status d'une reponse HTTP
 */
export function createObjetErrorStatus(code, text) {
    return { code, text };
}



// WEBPACK FOOTER //
// ./src/utils/actionsUtils.js